import React from 'react';
import { getRegions } from '../../../../utils/parks/getters';
import { HolidayType } from '../../../../utils/parks/types';
import { getParkNameByCode } from '../../../SearchEntryWidget/defaultData';
import LocationSelect from '../../../SearchForm/children/LocationSelect';
export const TouringParkSelector = ({ onSelect, value, dogSelected, handleGTMFilterChange, tourerTypeSelected, tourerLengthSelected, }) => {
    const innerOnSelect = (val) => {
        onSelect(val);
        if (handleGTMFilterChange) {
            handleGTMFilterChange('location', getParkNameByCode(val));
        }
    };
    const filterParksByTourerParams = (park) => {
        if (!tourerLengthSelected)
            return true;
        const lowercaseType = tourerTypeSelected === null || tourerTypeSelected === void 0 ? void 0 : tourerTypeSelected.toLowerCase();
        const matchingType = lowercaseType && park.touring.available ? park.touring[lowercaseType] : null;
        if (!matchingType)
            return false;
        return matchingType.available && matchingType.allowedLength.includes(tourerLengthSelected);
    };
    const filteredRegions = getRegions(HolidayType.TOURING).map((region) => {
        return Object.assign(Object.assign({}, region), { parks: region.parks.filter((park) => filterParksByTourerParams(park)) });
    });
    return (<div className='bl-haven-regionParkSelector'>
      <LocationSelect value={value} regions={filteredRegions} onChange={innerOnSelect} dogSelected={dogSelected}/>
    </div>);
};
